/**
 * setTimeout wrapper to use with async/await
 * used: await delay(1000);
 * @param ms
 * @returns
 */
export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
